import React from "react";
import { Modal, Dialog, DialogTitle, DialogContent, Stack, Typography, Box } from "@mui/material";
import zIndex from "../../designTokens/zIndex";
import { CardPostMetric } from "../Card/CardPostMeric";

export const TopPerformanceModal = ({
  open,
  onClose,
  topViewsThreads,
  topEngagementRateThreads,
  topEngagementAmountThreads,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{
        zIndex: zIndex.modal,
        '& .MuiDialog-paper': {
          height: 'calc(100vh - 64px)',
          maxHeight: 'calc(100vh - 64px)',
        },
      }}
    >
      <DialogTitle>Top Performance Threads</DialogTitle>
      <DialogContent>
        <Stack 
          direction="row" 
          spacing={2} 
          sx={{ 
            height: 'calc(100vh - 196px)',
            mt: 1,
          }}
        >
          <Stack sx={{ flex: 1, height: '100%' }}>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 1.25 }}>
              Top Views
            </Typography>
            <Box 
              sx={{ 
                height: 'calc(100% - 56px)', 
                overflowY: 'auto',
                pr: 1,
              }}
            >
              {topViewsThreads.map((thread, index) => (
                <CardPostMetric
                  key={thread.id}
                  date={thread.timestamp}
                  thread={thread}
                  isRemarkable={thread.isRemarkable}
                  borderType="bottom"
                  size="xl"
                  rd={0}
                  rank={index+1}
                  isRanked={true}
                />
              ))}
            </Box>
          </Stack>
          <Stack sx={{ flex: 1, height: '100%' }}>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 1.25 }}>
              Top Engagement Rate
            </Typography>
            <Box 
              sx={{ 
                height: 'calc(100% - 56px)', 
                overflowY: 'auto',
                pr: 1,
              }}
            >
              {topEngagementRateThreads.map((thread, index) => (
                <CardPostMetric
                  key={thread.id}
                  date={thread.timestamp}
                  thread={thread}
                  borderType="bottom"
                  isRemarkable={thread.isRemarkable}
                  size="xl"
                  rd={0}
                  isRanked={true}
                  rank={index+1}
                />
              ))}
            </Box>
          </Stack>
          <Stack sx={{ flex: 1, height: '100%' }}>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 1.25 }}>
              Top Engagement Amount
            </Typography>
            <Box 
              sx={{ 
                height: 'calc(100% - 56px)', 
                overflowY: 'auto',
                pr: 1,
              }}
            >
              {topEngagementAmountThreads.map((thread, index) => (
                <CardPostMetric
                  key={thread.id}
                  date={thread.timestamp}
                  isRemarkable={thread.isRemarkable}
                  thread={thread}
                  borderType="bottom"
                  size="xl"
                  rd={0}
                  isRanked={true}
                  rank={index+1}
                />
              ))}
            </Box>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}; 